import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { GetCepByMonthAndProductOrTaType } from 'generated/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_CEPS_BY_MONTH_AND_PRODUCT_OR_TA_LAZY = gql`
query GetCustomerEngagementPlanningsByMonthAndProductOrTaLazy($filters: DashboardFilter!, $category: String!) {
  getCustomerEngagementPlanningsByMonthAndProductOrTa(filters: $filters, category: $category) {
    period
    activeCeps {
      categoryName
      countOfCeps
    }
  }
}
`;

type ResultType = {
  getCustomerEngagementPlanningsByMonthAndProductOrTa: GetCepByMonthAndProductOrTaType[];
};

type UseGetCepsByMonthAndProductOrTaLazy = () => {
  getCepsByMonthAndProductOrTaLazyQuery: Function;
  loading: boolean;
  error?: ApolloError;
  data: GetCepByMonthAndProductOrTaType[];
};

const useGetCepsByMonthAndProductOrTaLazyQuery: UseGetCepsByMonthAndProductOrTaLazy = () => {
  const [
    getCepsByMonthAndProductOrTaLazyQuery,
    { data, loading, error },
  ] = useLazyQuery<ResultType>(GET_CEPS_BY_MONTH_AND_PRODUCT_OR_TA_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName:
        'getCustomerEngagementPlanningsByMonthAndProductOrTaLazy.ts - useGetCepsByMonthAndProductOrTaLazyQuery',
    });
  }

  return {
    getCepsByMonthAndProductOrTaLazyQuery,
    data: data?.getCustomerEngagementPlanningsByMonthAndProductOrTa || [],
    loading,
    error,
  };
};

export default useGetCepsByMonthAndProductOrTaLazyQuery;
